export const APISettings = {
    headers: new Headers({
        'Accept': 'application/json'
    }),
    //baseURL: window.location.origin+'/wp-json/',
    baseURL: '/api/',

    refreshJwt: (data)=>{
        if(data){
            localStorage.setItem("jwt",data);
        }
    }
}